import React, { useState, useEffect } from 'react';
import './style/App.scss';
import { connect } from 'react-redux';
// Components
import Test from './pages/TestPage';

// Pages
import Home from './pages/Home';
import LogIn from './components/public/LogIn';
import DashBoard from './pages/private/DashBoard';
import About from './pages/About';
import Arts from './pages/Arts';
import Kyagu from './pages/Kyagu';
import Kyagu1 from './pages/Kyagu1';
import LodueRinchen from './pages/LodueRinchen';
import Kyagu2 from './pages/Kyagu2';
import Kyagu3 from './pages/Kyagu3';
import Kyagu4 from './pages/Kyagu4';
import Kyagu5 from './pages/Kyagu5';
import Teaching1 from './pages/Teaching1';
import HowToRun from './pages/HowToRun';
import Teaching2 from './pages/Teaching2';
import Teaching3 from './pages/Teaching3';
import Teaching4 from './pages/Teaching4';
import TeachingTimeLine from './pages/TeachingTimeLine';
import Gallery from './pages/Gallery';
import DreamYoga from './pages/DreamYoga';
import School1 from './pages/School1';
import ChimeClinic from './pages/ChimeClinic';
import Calligraphy from './pages/Calligraphy';
import Exhibition from './pages/Exhibition';
import Schedule from './pages/Schedule';
import Mentse from './pages/Mentse';
import Charity from './pages/Charity';
import Monastery from './pages/Monastery';
import People from './pages/People';


// Router
import { BrowserRouter as Router, Route } from 'react-router-dom';
import PrivateRoute from './components/route/PrivateRoute';
import PublicRoute from './components/route/PublicRoute';
// Redux
import * as actionType from './store/action';
//Firebase
import app from './components/firebase/fire';
// BootStrap
import { Spinner } from 'react-bootstrap';

function App(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(null);
  useEffect(() => {
    app.auth().onAuthStateChanged((user) => {
      setIsAuth(!!user);
      if (user != null) {
        props.changeAuth(!!user, user.email, user.uid);
      }
      setIsLoading(false);
    });
  }, [isAuth]);

  if (isLoading) {
    return (
      <div className='d-flex vh-100 align-items-center justify-content-center'>
        <Spinner animation='border' role='status'>
          <span className='sr-only'>Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <Router>
      <div className='App'>
        <PrivateRoute exact path='/admin' component={DashBoard} />
        <PublicRoute exact path='/login' component={LogIn} />
        <PublicRoute exact path='/test' component={Test} />
        <PublicRoute exact path='/gallery' component={Gallery} />
        <PublicRoute exact path='/about' component={About} />
        <PublicRoute exact path='/arts' component={Arts} />
        <PublicRoute exact path='/kyagu' component={Kyagu} />
        <PublicRoute exact path='/kyagu1' component={Kyagu1} />
        <PublicRoute exact path='/kyagu2' component={Kyagu2} />
        <PublicRoute exact path='/kyagu3' component={Kyagu3} />
        <PublicRoute exact path='/kyagu4' component={Kyagu4} />
        <PublicRoute exact path='/lodue' component={LodueRinchen} />
        <PublicRoute exact path='/kyagu5' component={Kyagu5} />
        <PublicRoute exact path='/teaching1' component={Teaching1} />
        <PublicRoute exact path='/teaching2' component={Teaching2} />
        <PublicRoute exact path='/teaching3' component={Teaching3} />
        <PublicRoute exact path='/teaching4' component={Teaching4} />
        <PublicRoute exact path='/howToRun' component={HowToRun} />
        <PublicRoute exact path='/dream' component={DreamYoga} />
        <PublicRoute exact path='/school1' component={School1} />
        <PublicRoute exact path='/chimeClinic' component={ChimeClinic} />
        <PublicRoute exact path='/calligraphy' component={Calligraphy} />
        <PublicRoute exact path='/exhibition' component={Exhibition} />
        <PublicRoute exact path='/schedule' component={Schedule} />
        <PublicRoute exact path='/mentse' component={Mentse} />
        <PublicRoute exact path='/charity' component={Charity} />
        <PublicRoute exact path='/monastery' component={Monastery} />
        <PublicRoute exact path='/people' component={People} />

        <Route exact path='/' component={Home} />
        <PublicRoute
          exact
          path='/teachingTimeLine'
          component={TeachingTimeLine}
        />
      </div>
    </Router>
  );
}

const mapActionToProps = (dispatch) => {
  return {
    changeAuth: (isLogin, email, uid) =>
      dispatch({
        type: actionType.UPDATE,
        isLogIn: isLogin,
        email: email,
        uid: uid,
      }),
  };
};

export default connect('', mapActionToProps)(App);
